const products = [
  {
    _id: "HK1001",
    sku: "HK-FOOD-001",
    name: "Homemade Mango Pickle",
    slug: "homemade-mango-pickle",
    category: "Food",
    subCategory: "Pickles",
    brand: "FoundHer Kitchen",
    entrepreneur: "Anita Sharma",
    entrepreneurId: "FH001",
    store: "Anita's Homemade Foods",
    storeId: "STORE001",
    locality: "Andheri West",
    city: "Mumbai",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1604908554007-54a88d0d55f5?w=600"
    ],
    shortDescription: "Traditional homemade mango pickle.",
    mrp: 260,
    sellingPrice: 220,
    stock: 40,
    unit: "500 gm",
    rating: 4.8,
    totalRatings: 182,
    featured: true,
    bestseller: true,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1002",
    sku: "HK-FOOD-002",
    name: "Masala Papad Pack",
    slug: "masala-papad-pack",
    category: "Food",
    subCategory: "Snacks",
    brand: "FoundHer Kitchen",
    entrepreneur: "Priya Nair",
    entrepreneurId: "FH002",
    store: "Priya Foods",
    storeId: "STORE002",
    locality: "Powai",
    city: "Mumbai",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1601050690597-df0568f70950?w=600"
    ],
    shortDescription: "Crispy homemade masala papad.",
    mrp: 180,
    sellingPrice: 150,
    stock: 65,
    unit: "Pack",
    rating: 4.7,
    totalRatings: 96,
    featured: false,
    bestseller: false,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1003",
    sku: "HK-BEAUTY-001",
    name: "Handmade Aloe Vera Soap",
    slug: "handmade-aloe-vera-soap",
    category: "Beauty",
    subCategory: "Soap",
    brand: "NatureHer",
    entrepreneur: "Megha Joshi",
    entrepreneurId: "FH003",
    store: "NatureHer Essentials",
    storeId: "STORE003",
    locality: "Baner",
    city: "Pune",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1607006483225-86f8f7d6f0e3?w=600"
    ],
    shortDescription: "Natural handmade bathing soap.",
    mrp: 180,
    sellingPrice: 149,
    stock: 120,
    unit: "100 gm",
    rating: 4.9,
    totalRatings: 284,
    featured: true,
    bestseller: true,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1004",
    sku: "HK-BEAUTY-002",
    name: "Rose Lip Balm",
    slug: "rose-lip-balm",
    category: "Beauty",
    subCategory: "Lip Care",
    brand: "NatureHer",
    entrepreneur: "Megha Joshi",
    entrepreneurId: "FH003",
    store: "NatureHer Essentials",
    storeId: "STORE003",
    locality: "Baner",
    city: "Pune",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1619451334792-150fd785ee74?w=600"
    ],
    shortDescription: "Organic moisturizing lip balm.",
    mrp: 199,
    sellingPrice: 169,
    stock: 88,
    unit: "15 gm",
    rating: 4.6,
    totalRatings: 112,
    featured: false,
    bestseller: false,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1005",
    sku: "HK-FASHION-001",
    name: "Cotton Kurti",
    slug: "cotton-kurti",
    category: "Fashion",
    subCategory: "Women Wear",
    brand: "HerThreads",
    entrepreneur: "Ritu Verma",
    entrepreneurId: "FH004",
    store: "HerThreads Boutique",
    storeId: "STORE004",
    locality: "Nashik Road",
    city: "Nashik",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=600"
    ],
    shortDescription: "Soft breathable cotton kurti.",
    mrp: 1199,
    sellingPrice: 899,
    stock: 22,
    unit: "Piece",
    rating: 4.7,
    totalRatings: 164,
    featured: true,
    bestseller: true,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1006",
    sku: "HK-FASHION-002",
    name: "Handcrafted Dupatta",
    slug: "handcrafted-dupatta",
    category: "Fashion",
    subCategory: "Accessories",
    brand: "HerThreads",
    entrepreneur: "Ritu Verma",
    entrepreneurId: "FH004",
    store: "HerThreads Boutique",
    storeId: "STORE004",
    locality: "Nashik Road",
    city: "Nashik",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?w=600"
    ],
    shortDescription: "Elegant handcrafted dupatta.",
    mrp: 699,
    sellingPrice: 549,
    stock: 35,
    unit: "Piece",
    rating: 4.5,
    totalRatings: 78,
    featured: false,
    bestseller: false,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1007",
    sku: "HK-HOME-001",
    name: "Decorative Cushion Cover",
    slug: "decorative-cushion-cover",
    category: "Home",
    subCategory: "Home Decor",
    brand: "HomeNest",
    entrepreneur: "Neha Kapoor",
    entrepreneurId: "FH005",
    store: "HomeNest Creations",
    storeId: "STORE005",
    locality: "Kharadi",
    city: "Pune",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=600"
    ],
    shortDescription: "Premium embroidered cushion cover.",
    mrp: 450,
    sellingPrice: 349,
    stock: 52,
    unit: "Piece",
    rating: 4.8,
    totalRatings: 132,
    featured: true,
    bestseller: false,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1008",
    sku: "HK-HOME-002",
    name: "Handmade Scented Candle",
    slug: "handmade-scented-candle",
    category: "Home",
    subCategory: "Decor",
    brand: "HomeNest",
    entrepreneur: "Neha Kapoor",
    entrepreneurId: "FH005",
    store: "HomeNest Creations",
    storeId: "STORE005",
    locality: "Kharadi",
    city: "Pune",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1603006905003-be475563bc59?w=600"
    ],
    shortDescription: "Soy wax lavender scented candle.",
    mrp: 350,
    sellingPrice: 299,
    stock: 44,
    unit: "Piece",
    rating: 4.9,
    totalRatings: 208,
    featured: true,
    bestseller: true,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },
    ,
  {
    _id: "HK1009",
    sku: "HK-HANDMADE-001",
    name: "Macrame Wall Hanging",
    slug: "macrame-wall-hanging",
    category: "Handmade",
    subCategory: "Wall Decor",
    brand: "CraftHer",
    entrepreneur: "Sneha Kulkarni",
    entrepreneurId: "FH006",
    store: "CraftHer Studio",
    storeId: "STORE006",
    locality: "Thane West",
    city: "Mumbai",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1513694203232-719a280e022f?w=600"
    ],
    shortDescription: "Handwoven macrame wall decor.",
    mrp: 1499,
    sellingPrice: 1199,
    stock: 18,
    unit: "Piece",
    rating: 4.9,
    totalRatings: 96,
    featured: true,
    bestseller: false,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1010",
    sku: "HK-HANDMADE-002",
    name: "Crochet Table Mat",
    slug: "crochet-table-mat",
    category: "Handmade",
    subCategory: "Dining",
    brand: "CraftHer",
    entrepreneur: "Sneha Kulkarni",
    entrepreneurId: "FH006",
    store: "CraftHer Studio",
    storeId: "STORE006",
    locality: "Thane West",
    city: "Mumbai",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=600"
    ],
    shortDescription: "Hand crocheted premium dining mat.",
    mrp: 499,
    sellingPrice: 399,
    stock: 40,
    unit: "Piece",
    rating: 4.7,
    totalRatings: 62,
    featured: false,
    bestseller: false,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1011",
    sku: "HK-JEWELLERY-001",
    name: "Oxidised Necklace Set",
    slug: "oxidised-necklace-set",
    category: "Jewellery",
    subCategory: "Necklace",
    brand: "ShineHer",
    entrepreneur: "Pooja Mehta",
    entrepreneurId: "FH007",
    store: "ShineHer Jewellery",
    storeId: "STORE007",
    locality: "Vashi",
    city: "Navi Mumbai",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1617038220319-276d3cfab638?w=600"
    ],
    shortDescription: "Elegant oxidised necklace set.",
    mrp: 999,
    sellingPrice: 799,
    stock: 30,
    unit: "Set",
    rating: 4.8,
    totalRatings: 215,
    featured: true,
    bestseller: true,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1012",
    sku: "HK-JEWELLERY-002",
    name: "Pearl Earrings",
    slug: "pearl-earrings",
    category: "Jewellery",
    subCategory: "Earrings",
    brand: "ShineHer",
    entrepreneur: "Pooja Mehta",
    entrepreneurId: "FH007",
    store: "ShineHer Jewellery",
    storeId: "STORE007",
    locality: "Vashi",
    city: "Navi Mumbai",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=600"
    ],
    shortDescription: "Minimal pearl earrings.",
    mrp: 499,
    sellingPrice: 399,
    stock: 54,
    unit: "Pair",
    rating: 4.6,
    totalRatings: 89,
    featured: false,
    bestseller: false,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1013",
    sku: "HK-HEALTH-001",
    name: "Organic Multigrain Flour",
    slug: "organic-multigrain-flour",
    category: "Health",
    subCategory: "Organic Food",
    brand: "HealthyHer",
    entrepreneur: "Sonia Gupta",
    entrepreneurId: "FH008",
    store: "HealthyHer Foods",
    storeId: "STORE008",
    locality: "Dadar",
    city: "Mumbai",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1603048297172-c92544798d5b?w=600"
    ],
    shortDescription: "Stone ground nutritious flour.",
    mrp: 240,
    sellingPrice: 199,
    stock: 90,
    unit: "1 Kg",
    rating: 4.8,
    totalRatings: 171,
    featured: true,
    bestseller: false,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1014",
    sku: "HK-HEALTH-002",
    name: "Cold Pressed Coconut Oil",
    slug: "cold-pressed-coconut-oil",
    category: "Health",
    subCategory: "Organic",
    brand: "HealthyHer",
    entrepreneur: "Sonia Gupta",
    entrepreneurId: "FH008",
    store: "HealthyHer Foods",
    storeId: "STORE008",
    locality: "Dadar",
    city: "Mumbai",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1606755962773-d324e0a13086?w=600"
    ],
    shortDescription: "Pure cold pressed coconut oil.",
    mrp: 520,
    sellingPrice: 449,
    stock: 61,
    unit: "500 ml",
    rating: 4.9,
    totalRatings: 143,
    featured: true,
    bestseller: true,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1015",
    sku: "HK-KIDS-001",
    name: "Crochet Teddy Bear",
    slug: "crochet-teddy-bear",
    category: "Kids",
    subCategory: "Soft Toys",
    brand: "TinyHands",
    entrepreneur: "Komal Shah",
    entrepreneurId: "FH009",
    store: "TinyHands Creations",
    storeId: "STORE009",
    locality: "Borivali",
    city: "Mumbai",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1545558014-8692077e9b5c?w=600"
    ],
    shortDescription: "Handmade crochet teddy.",
    mrp: 899,
    sellingPrice: 749,
    stock: 27,
    unit: "Piece",
    rating: 4.9,
    totalRatings: 121,
    featured: true,
    bestseller: false,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1016",
    sku: "HK-STATIONERY-001",
    name: "Handcrafted Journal",
    slug: "handcrafted-journal",
    category: "Stationery",
    subCategory: "Notebook",
    brand: "PaperBloom",
    entrepreneur: "Divya Rao",
    entrepreneurId: "FH010",
    store: "PaperBloom Studio",
    storeId: "STORE010",
    locality: "Wakad",
    city: "Pune",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1517842645767-c639042777db?w=600"
    ],
    shortDescription: "Premium handmade journal.",
    mrp: 499,
    sellingPrice: 399,
    stock: 73,
    unit: "Piece",
    rating: 4.8,
    totalRatings: 104,
    featured: false,
    bestseller: false,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },
    {
    _id: "HK1017",
    sku: "HK-BOOKS-001",
    name: "Positive Living Journal",
    slug: "positive-living-journal",
    category: "Books",
    subCategory: "Self Improvement",
    brand: "MindBloom",
    entrepreneur: "Aarti Deshpande",
    entrepreneurId: "FH011",
    store: "MindBloom Books",
    storeId: "STORE011",
    locality: "Aundh",
    city: "Pune",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=600"
    ],
    shortDescription: "Daily gratitude and reflection journal.",
    mrp: 399,
    sellingPrice: 329,
    stock: 55,
    unit: "Piece",
    rating: 4.8,
    totalRatings: 143,
    featured: true,
    bestseller: false,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1018",
    sku: "HK-GIFTS-001",
    name: "Personalised Gift Hamper",
    slug: "personalised-gift-hamper",
    category: "Gifts",
    subCategory: "Gift Box",
    brand: "GiftNest",
    entrepreneur: "Shweta Patil",
    entrepreneurId: "FH012",
    store: "GiftNest Studio",
    storeId: "STORE012",
    locality: "Kothrud",
    city: "Pune",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1512909006721-3d6018887383?w=600"
    ],
    shortDescription: "Beautifully packed handmade gift hamper.",
    mrp: 1499,
    sellingPrice: 1249,
    stock: 18,
    unit: "Box",
    rating: 4.9,
    totalRatings: 91,
    featured: true,
    bestseller: true,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1019",
    sku: "HK-ORGANIC-001",
    name: "Organic Turmeric Powder",
    slug: "organic-turmeric-powder",
    category: "Organic",
    subCategory: "Spices",
    brand: "PureHarvest",
    entrepreneur: "Kavita Singh",
    entrepreneurId: "FH013",
    store: "PureHarvest Organics",
    storeId: "STORE013",
    locality: "Mulund",
    city: "Mumbai",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1615485291234-9fbcf0f2d8c4?w=600"
    ],
    shortDescription: "Farm sourced organic turmeric.",
    mrp: 220,
    sellingPrice: 185,
    stock: 86,
    unit: "250 gm",
    rating: 4.8,
    totalRatings: 176,
    featured: false,
    bestseller: true,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  },

  {
    _id: "HK1020",
    sku: "HK-SERVICES-001",
    name: "Mehendi Design Session",
    slug: "mehendi-design-session",
    category: "Services",
    subCategory: "Beauty Service",
    brand: "HerArt",
    entrepreneur: "Farah Khan",
    entrepreneurId: "FH014",
    store: "HerArt Studio",
    storeId: "STORE014",
    locality: "Mira Road",
    city: "Mumbai",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=600"
    ],
    shortDescription: "Professional mehendi appointment.",
    mrp: 1200,
    sellingPrice: 999,
    stock: 999,
    unit: "Session",
    rating: 4.9,
    totalRatings: 208,
    featured: true,
    bestseller: false,
    cod: true,
    pickup: false,
    localDelivery: false,
    isActive: true
  },

  {
    _id: "HK1021",
    sku: "HK-OTHERS-001",
    name: "Eco Friendly Gift Bag",
    slug: "eco-friendly-gift-bag",
    category: "Others",
    subCategory: "Utility",
    brand: "GreenCraft",
    entrepreneur: "Rekha Iyer",
    entrepreneurId: "FH015",
    store: "GreenCraft Studio",
    storeId: "STORE015",
    locality: "Chembur",
    city: "Mumbai",
    state: "Maharashtra",
    images: [
      "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=600"
    ],
    shortDescription: "Reusable handmade cloth gift bag.",
    mrp: 199,
    sellingPrice: 149,
    stock: 120,
    unit: "Piece",
    rating: 4.7,
    totalRatings: 84,
    featured: false,
    bestseller: false,
    cod: true,
    pickup: true,
    localDelivery: true,
    isActive: true
  }
];

export const productCategories = [
  "All",
  "Food",
  "Fashion",
  "Beauty",
  "Home",
  "Handmade",
  "Gifts",
  "Books",
  "Stationery",
  "Health",
  "Organic",
  "Crafts",
  "Jewellery",
  "Kids",
  "Services",
  "Others"
];

export const sortOptions = [
  {
    label: "Newest",
    value: "newest"
  },
  {
    label: "Price: Low to High",
    value: "priceAsc"
  },
  {
    label: "Price: High to Low",
    value: "priceDesc"
  },
  {
    label: "Highest Rated",
    value: "rating"
  },
  {
    label: "Best Sellers",
    value: "bestseller"
  }
];

export default products;